/*
Copyright (C) 2017  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import * as React from "react";
import styled from "styled-components";

import Navigation from "@src/components/modules/NavigationModule/Navigation";
import TopBar from "@src/components/modules/TemplateModule/TopBar";
import { ThemePalette } from "@src/components/Theme";

/*
 * The New transfer wizard in the same frame as every other Swift page: the sidebar (Transfers
 * highlighted) and the shared top bar ("Swift > Transfers > New transfer"), with the wizard's own
 * step navigation filling the workspace. `pageHeaderComponent` is accepted but no longer mounted:
 * the top bar is the template's own.
 */
const Wrapper = styled.div<any>`
  display: flex;
  height: 100%;
  min-height: 0;
  background: ${ThemePalette.grayscale[7]};
`;
const Main = styled.div<any>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
`;
const PageContent = styled.div<any>`
  position: relative;
  flex-grow: 1;
  min-height: 0;
  min-width: 900px;
  overflow: auto;
`;

type Props = {
  pageHeaderComponent?: React.ReactNode;
  pageContentComponent: React.ReactNode;
};
const WizardTemplate = (props: Props) => (
  <Wrapper>
    <Navigation currentPage="transfers" />
    <Main>
      <TopBar />
      <PageContent>{props.pageContentComponent}</PageContent>
    </Main>
  </Wrapper>
);

export default WizardTemplate;
